import { Badge } from "@/components/ui/badge";

interface PricingToggleProps {
  billingPeriod: "monthly" | "annual";
  onBillingChange: (period: "monthly" | "annual") => void;
}

export const PricingToggle = ({ billingPeriod, onBillingChange }: PricingToggleProps) => {
  return (
    <div className="flex justify-center items-center gap-4">
      <button
        onClick={() => onBillingChange("annual")}
        className={`px-6 py-3 rounded-lg font-semibold transition-all relative ${
          billingPeriod === "annual"
            ? "bg-primary text-primary-foreground shadow-enhanced"
            : "text-foreground"
        }`}
      >
        Yearly
        {billingPeriod === "annual" && (
          <Badge className="ml-2 bg-amber-500 text-white border-0">
            Save 18%
          </Badge>
        )}
      </button>
      <button
        onClick={() => onBillingChange("monthly")}
        className={`px-6 py-3 rounded-lg font-semibold transition-all ${
          billingPeriod === "monthly"
            ? "bg-primary text-primary-foreground shadow-enhanced"
            : "text-foreground"
        }`}
      >
        Monthly
      </button>
      <div className="ml-4 text-sm text-muted-foreground">
        Prices are in EUR
      </div>
    </div>
  );
};
